import React from "react";

/** Context: provides currentUser object and setter for it throughout app. */

const UserContext = React.createContext();

export default UserContext;
